import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Model } from 'src/app/app.model';
import { Subscription } from 'src/app/subscription/subscription.model';
import { SubscriptionService } from 'src/app/subscription/subscription.service';
import { WorkflowPartnerService } from '../workflow-partner.service';
import { firstValueFrom } from 'rxjs';
import { WorkflowComponent } from '../../workflow.component';
import { tariffFlatNames } from 'src/app/tariff/tariff.model';

@Component({
    selector: 'app-workflow-partner-one-tariff-order-cancel',
    templateUrl: './workflow-partner-one-tariff-order-cancel.component.html',
    standalone: false
})
export class WorkflowPartnerOneTariffOrderCancelComponent extends WorkflowComponent implements OnInit {

    public subscription: Subscription;

    constructor(
        protected route: ActivatedRoute,
        protected m: Model,
        protected router: Router,
        protected subscriptionService: SubscriptionService,
        protected workflowPartnerService: WorkflowPartnerService,
    ) {
        super();
    }

    async ngOnInit() {
        super.ngOnInit();
        this.setStep('order-cancel');
        if (this.applianceId && !this.subscription) {
            this.subscriptionService.getSubscriptionDetails(+this.applianceId).subscribe(async r => {
                this.subscription = Subscription.fromJson(r);
            });
        }
    }

    private setStep(step: string) {
        this.step = step;
    }

    onBack() {
        this.resetWorkflow();
    }

    async onConfirm() {
        try {
            const orderWithTariff = this.subscription?.orders?.find(order =>
                order?.lines?.some(line => tariffFlatNames.includes(line?.product))
            );

            if (orderWithTariff) {
                await firstValueFrom(this.workflowPartnerService.oneApplianceCancelTariffOrder(orderWithTariff.name));
            }

            this.resetWorkflow();
        } catch (e) {
            console.error('Cancel tariff order failed', e);
            this.resetWorkflow();
        }
    }
}
